module.exports = __webpack_public_path__ + "static/img/home.16788029.svg";